import { useTranslation } from "react-i18next";

const cards = [
  { key: "organized", icon: "ri-folders-line" },
  { key: "comparisons", icon: "ri-arrow-left-right-line" },
  { key: "updated", icon: "ri-time-line" },
  { key: "safetyFirst", icon: "ri-shield-check-line" },
  { key: "multilingual", icon: "ri-global-line" },
  { key: "independent", icon: "ri-user-community-line" },
];

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            {t("trust.h2")}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {cards.map((card) => (
            <div
              key={card.key}
              className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300/50 transition-all"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center mb-4">
                <i className={`${card.icon} text-lg md:text-xl`} />
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-base md:text-lg mb-2">
                {t(`trust.cards.${card.key}.title`)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t(`trust.cards.${card.key}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}